export default [
    {
        name: "firstName",
        label: "First Name",
        type: "string",
        helpText: "string",
        errorMessage: "First Name is required",
        validation: {
            required: true,
        },
    },
    {
        name: "lastName",
        label: "Last Name",
        type: "string",
        helpText: "string",
        errorMessage: "Last Name is required",
        validation: {
            required: true,
        },
    },
    {
        name: "email",
        label: "Email",
        type: "string",
        helpText: "Email",
        errorMessage: "Email is required and should follow this pattern i.e. john@example.com",
        validation: {
            pattern: /\S+@\S+\.\S+/,
            required: true,
        },
    },
    {
        name: "roleIds",
        label: "Roles",
        type: "list",
        helpText: "Roles",
        url: "/roles",
        filterValue: "name",
        isMultiple: true,
        entityName: "roles",
        formatLabels: true,
        include: true,
    },
    {
        name: "password",
        label: "Password",
        type: "password",
        errorMessage: "Password is required",
        validation: {
            required: true,
        },
    },
    {
        name: "passwordConfirmation",
        label: "Password Confirmation",
        type: "passwordConfirmation",
        errorMessage: "Password confirmation doesn't match password",
    },
];
